import { useCallback, useEffect, useState } from "react";
import { serviceGetList } from "../../../../services/index.services";
import { useDispatch } from "react-redux";
import { resetForm } from "../../../../actions/UserForm.action";

function useTopFieldHook({ form }) {
  const [listData, setListData] = useState({
    CLIENTS: [],
    PROGRAMS: [],
    STATES: [],
    CITIES: [],
  });
  const dispatch = useDispatch();

  useEffect(() => {
    const fetchStaticDropdowns = async () => {
      const res = await serviceGetList(["CLIENTS", "STATES"]);
      if (!res?.error) {
        setListData((prev) => ({
          ...prev,
          CLIENTS: res?.data?.CLIENTS || [],
          STATES: res?.data?.STATES
            ? [{ id: "PAN_INDIA", label: "Pan India" }, ...res?.data?.STATES]
            : [],
        }));
      }
    };

    fetchStaticDropdowns();
  }, []);

  useEffect(() => {
    const clientId = form?.client_id;
    if (!clientId) {
      setListData((prev) => ({ ...prev, PROGRAMS: [] }));
      return;
    }

    const fetchPrograms = async () => {
      const res = await serviceGetList(["PROGRAMS"], { client_id: clientId });
      if (!res?.error) {
        setListData((prev) => ({
          ...prev,
          PROGRAMS: res?.data?.PROGRAMS || [],
        }));
      }
    };

    fetchPrograms();
  }, [form?.client_id]);

  useEffect(() => {
    const StateID = form?.state_ids;
    if (!StateID) {
      setListData((prev) => ({ ...prev, CITIES: [] }));
      return;
    }
    const fetchCities = async () => {
      const filteredStateIds =
        StateID?.filter((val) => val?.id && val?.id !== "PAN_INDIA")?.map(
          (val) => val.id
        ) || [];

      const res = await serviceGetList(["CITIES"], {
        state_ids: filteredStateIds,
      });
      if (!res?.error) {
        setListData((prev) => ({
          ...prev,
          CITIES: res?.data?.CITIES
            ? [{ id: "ALL_CITIES", label: "All Cities" }, ...res?.data?.CITIES]
            : [],
        }));
      }
    };

    fetchCities();
  }, [form?.state_ids]);

  return {
    listData,
  };
}

export default useTopFieldHook;
